import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../header/Header';
import Policies from '../../components/policies/Policies';
import Loader from '../../components/loader/Loader';

function PoliciesPage() {

    return (
        <>
            <Header />
            <Container fluid className="main-dashboard-container">
                <Policies />
            </Container>
        </>
    );
}

export default PoliciesPage;

